module.exports = __webpack_public_path__ + "img/54.26b3080c.webp";